import { LitElement } from 'lit'
import { customElement } from 'lit/decorators.js'

import { injectLegacyLightDomStyles } from '../common/light-dom-styles.js'
import { DraftComponentMixin } from '../common/mixins/DraftComponentMixin.js'
import style from './primitives.css'

/**
 * The "next page" control in a composed [Pagination](/components/pagination/). A
 * layout wrapper around your own interactive element — provide an `<a>` (e.g. a
 * framework `<Link>`) or a `nord-button` with its own icon, label and
 * navigation, and disable it when there is no next page.
 *
 * @status draft
 * @category navigation
 * @lightDom true
 *
 * @slot - Default slot for the next-page link or button.
 */
@customElement('nord-pagination-next')
export default class PaginationNext extends DraftComponentMixin(LitElement) {
  connectedCallback() {
    super.connectedCallback()
    injectLegacyLightDomStyles(this, style)
  }

  protected createRenderRoot() {
    return this
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'nord-pagination-next': PaginationNext
  }
}
